// src/components/global/Table/LoadingStateRow.jsx
import React from 'react';
import { Box, CircularProgress, TableRow, TableCell, Typography } from '@mui/material';

const LoadingStateRow = ({ colSpan, isArabic }) => {
    return (
        <TableRow>
            <TableCell colSpan={colSpan} align="center" sx={{ py: 4 }}>
                <Box display="flex" alignItems="center" justifyContent="center" gap={2}>
                    <CircularProgress size={24} />
                    <Typography variant="body1">
                        {isArabic ? 'جاري تحميل البيانات، الرجاء الانتظار...' : 'Loading data, please wait...'}
                    </Typography>
                </Box>
            </TableCell>
        </TableRow>
    );
};

export default LoadingStateRow;
